import { CircularProgress, IconButton, styled, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

const ContainerBox = styled(Box)({
    position: 'relative',
    background: '#f1f3f5'
});


/**
 * 
 * @param {props} {
 *   file   - Javascript File object (see https://developer.mozilla.org/en-US/docs/Web/API/File) 
 *   status - string 'Queued' | 'Uploading', etc.
 *   id     - string unique id used by caller to identify this image (passed to remove callback)
 *   size   - number of pixels
 *   alt    - string html alt text
 *   remove - function to call back when user clicks delete icon
 *   sx     - sx styles property
 * @returns JSX
 */
export default function ClientImagePreview({file, status, id, size = 200, alt, remove, sx}) {

    const [objectUrl, setObjectUrl] = useState()

    useEffect(() => {
        if (file) {
            const newObjectUrl = URL.createObjectURL(file);
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl)
            }
            setObjectUrl(newObjectUrl)
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl)
            }
        }
    // eslint-disable-next-line 
    }, [file])

    let backgroundColor, borderColor
    switch (status) {
        case 'Uploaded':
            backgroundColor = borderColor = 'rgba(0,128,0,0.3)'
            break
        case 'Error':
            backgroundColor = borderColor = 'rgba(192,0,0,0.3)'
            break
        default:
            backgroundColor = 'rgba(0,0,0,0.3)'
            borderColor = 'transparent'
            break
    }
    const borderWidth = '3px'
    const OverlayBox = styled(Box)({
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-end',
        width:  `calc(100% - 2*${borderWidth})`,
        height: `calc(100% - 2*${borderWidth})`,
        zIndex: 10,
        background: `linear-gradient(${backgroundColor} 0 40px, transparent 40px 100%)`,
        border: `${borderWidth} solid ${borderColor}`,
        textAlign: 'right',
    });


    return (
        <ContainerBox sx={{...sx, width: size, height: size}}>
            <OverlayBox>
                <Box>
                    <ImageStatusIcon status={status} color="bright" sx={{display: 'inline-block', p: 1}} />
                </Box>
                <Box>
                    <Tooltip title="Delete" placement="top-start" arrow>
                        <IconButton color="bright" onClick={() => remove(id)} sx={{display: 'inline-block'}}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </OverlayBox>
            <img src={objectUrl} alt={alt || file.name} style={{maxWidth: size, maxHeight: size}} />
        </ContainerBox>
    )
}

function ImageStatusIcon({status, color, sx}) {
    let icon
    switch (status) {
        case 'Queued':
            icon = <HourglassEmptyIcon color={color} sx={sx} />
            break
        case 'Uploading':
            icon = <CircularProgress color={color} sx={sx} size="1.2em" />
            break
        case 'Uploaded':
            icon = <CheckCircleIcon color={color} sx={sx} />
            break
        case 'Error':
            icon = <ErrorIcon color={color} sx={sx} />
            break
        default:
            icon = null
            break
    }
    return icon
}
